import React, { useCallback } from 'react';
import classnames from 'classnames';
import Ripple from '../utils/Ripple';
import useHelpNoteTitle from '../utils/Translations/useHelpNoteTitle';
const Button = ({ buttonStyle = 'default', linkStyle = '', disabled = false, block = false, children = null, onClick, position = '', margin = '', size = '', isButton = true, additionClasses = '', dataId = '', padding = '', type = 'button', title = '', tooltipTitle = '', isRounded = false, forwardRef = null, id = '', style, dataCy = '', }) => {
    const resolvedTooltipTitle = useHelpNoteTitle(title, tooltipTitle);
    const handleClick = useCallback(event => onClick && onClick(event), [
        onClick,
    ]);
    const button = (
    //eslint-disable-next-line react/button-has-type
    <button className={classnames(additionClasses, {
        btn: isButton,
        'btn-xs': size === 'xs',
        'btn-sm': size === 'sm',
        'btn-lg': size === 'lg',
        'btn-block': block,
        'btn-primary': buttonStyle === 'primary',
        'btn-danger': buttonStyle === 'danger',
        'bg-indigo-400': buttonStyle === 'dark',
        'btn-link': buttonStyle === 'link',
        'btn-flat btn-minimal pr-10': buttonStyle === 'minimal',
        'btn-default': buttonStyle === 'default',
        'btn-rounded': isRounded,
        [margin]: margin,
        'no-padding': padding === 'no-padding',
        'pull-right': position === 'right',
        'pull-left': position === 'left',
        'clear-fields': linkStyle === 'clear-fields',
    })} data-cy={dataCy} data-id={dataId} disabled={disabled} id={id} 
    // eslint-disable-next-line react/forbid-dom-props
    style={style} title={resolvedTooltipTitle || title} type={type} onClick={handleClick}>
      {children}
    </button>);
    return (<Ripple childRef={forwardRef && (e => e && forwardRef(e[0]))}>
      {button}
    </Ripple>);
};
export default Button;
